const genderFromId = idNumber => {
  const genderDigit = parseInt(idNumber[6]);

  return genderDigit < 5 ? 'female' : 'male';
};

module.exports = {
  genderFromId
};



// WEBPACK FOOTER //
// ./src/helpers/gender.js